var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBgRaffleTickets = function SvgBgRaffleTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1491,
    height: 421,
    fill: "none",
    viewBox: "0 0 1491 421"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8257_3126)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M178.546 219.89c3.744 1.724 6.463 5.025 7.593 9.242l20.443 76.296c.584 2.179.726 4.537.416 6.939s-1.063 4.802-2.219 7.06a23.3 23.3 0 0 1-4.515 6.1c-1.825 1.769-3.906 3.2-6.121 4.209l-20.213 9.278c-3.272 1.507-6.728 2.024-9.93 1.485l-10.822-1.846-5.799-2.783 10.823 1.847c3.201.538 6.657.021 9.929-1.486l20.213-9.277c2.216-1.01 4.296-2.44 6.121-4.21a23.3 23.3 0 0 0 4.515-6.1c1.156-2.258 1.91-4.657 2.219-7.06.31-2.402.169-4.76-.415-6.939L180.34 226.35c-1.129-4.217-3.849-7.519-7.593-9.242z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_8257_3126)",
    fillRule: "evenodd",
    d: "m153.186 338.651-5.447 8.476c-2.301 3.541-5.521 6.392-9.173 8.121L76.26 383.845c-2.21 1.014-4.512 1.59-6.777 1.695-2.264.105-4.446-.264-6.42-1.085l-5.8-2.782c1.975.82 4.157 1.189 6.422 1.084s4.567-.68 6.777-1.695l62.305-28.597c3.652-1.728 6.873-4.579 9.174-8.12l5.446-8.476z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M62.473 384.197a13.4 13.4 0 0 1-4.503-3.44c-1.384-1.621-2.396-3.575-2.98-5.75l-20.442-76.296c-1.177-4.392-.533-9.419 1.79-13.973s6.136-8.264 10.599-10.312l62.406-28.644c3.675-1.655 7.558-2.062 11.04-1.157l8.348 2.144-5.798-2.783-8.349-2.144c-3.482-.905-7.364-.498-11.039 1.157l-62.407 28.644c-4.463 2.048-8.275 5.758-10.598 10.312-2.324 4.555-2.968 9.581-1.791 13.974l20.443 76.295c.583 2.175 1.595 4.129 2.98 5.75a13.4 13.4 0 0 0 4.502 3.44z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m128.727 246.771 7.47-10.243c2.243-3.038 5.189-5.459 8.463-6.956l20.213-9.278c4.463-2.048 9.211-2.268 13.199-.61l-5.799-2.783c-3.988-1.657-8.736-1.438-13.198.611l-20.213 9.277c-3.275 1.497-6.22 3.919-8.464 6.957l-7.47 10.242z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M143.654 287.745a4.4 4.4 0 0 0-2.171-.436c-1.024.047-2.067.415-2.995 1.057a6.95 6.95 0 0 0-2.223 2.549c-.52 1.02-.764 2.127-.701 3.181s.432 2.008 1.058 2.742c.363.425.804.765 1.3 1.008l-5.799-2.783a4.1 4.1 0 0 1-1.3-1.008c-.626-.733-.994-1.687-1.057-2.741-.064-1.055.18-2.162.7-3.182a6.96 6.96 0 0 1 2.223-2.549c.929-.641 1.971-1.009 2.995-1.057a4.4 4.4 0 0 1 2.171.436z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M137.924 297.847q.542.264 1.159.37c.978.165 2.033.008 3.032-.451 1.34-.615 2.485-1.729 3.183-3.096.698-1.368.891-2.877.538-4.197-.264-.983-.818-1.809-1.592-2.372a4 4 0 0 0-.588-.355l-5.799-2.783q.309.153.588.355c.775.563 1.329 1.389 1.592 2.373.354 1.319.16 2.828-.537 4.196s-1.843 2.482-3.183 3.097c-1 .458-2.055.615-3.032.45a4.2 4.2 0 0 1-1.159-.37zM149.89 311.105a4 4 0 0 0-.212-.095l-5.799-2.783q.107.045.212.095z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M149.675 311.01c-1.198-.497-2.623-.431-3.963.184a6.73 6.73 0 0 0-2.583 2.127 6.7 6.7 0 0 0-1.263 3.086c-.139 1.084.029 2.13.482 3.006a4.1 4.1 0 0 0 1.854 1.817l-5.798-2.783a4.1 4.1 0 0 1-1.855-1.817c-.453-.875-.621-1.921-.482-3.006a6.7 6.7 0 0 1 1.263-3.086 6.75 6.75 0 0 1 2.583-2.127c1.34-.615 2.766-.681 3.963-.183z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M144.204 321.229q.103.05.211.095l-5.799-2.782a5 5 0 0 1-.211-.095zM144.416 321.324c.893.371 1.921.431 2.953.174 1.031-.258 2.021-.823 2.843-1.624.823-.8 1.441-1.8 1.777-2.872.336-1.073.375-2.17.111-3.154-.332-1.24-1.122-2.216-2.21-2.743l-5.799-2.782c1.089.526 1.879 1.502 2.211 2.742.263.984.225 2.081-.111 3.154a6.95 6.95 0 0 1-1.777 2.873c-.823.8-1.813 1.365-2.844 1.623-1.032.258-2.059.197-2.952-.174z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M137.39 264.369a4.4 4.4 0 0 0-2.171-.436c-1.024.047-2.066.415-2.995 1.057a6.96 6.96 0 0 0-2.223 2.549c-.52 1.02-.764 2.127-.7 3.181.063 1.054.431 2.008 1.057 2.742.363.425.804.765 1.3 1.008l-5.798-2.783a4 4 0 0 1-1.3-1.008c-.626-.733-.994-1.687-1.058-2.742-.063-1.054.181-2.161.701-3.181a6.96 6.96 0 0 1 2.222-2.549c.929-.641 1.971-1.009 2.996-1.057a4.4 4.4 0 0 1 2.17.436z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M131.66 274.467q.54.264 1.159.37c.977.165 2.032.008 3.032-.451 1.34-.615 2.485-1.729 3.183-3.096.697-1.368.891-2.877.537-4.197-.263-.983-.817-1.809-1.592-2.372a4 4 0 0 0-.588-.355l-5.798-2.783q.308.153.588.355c.774.564 1.328 1.389 1.592 2.373.353 1.319.16 2.828-.538 4.196s-1.843 2.482-3.183 3.097c-.999.458-2.054.615-3.032.45a4.2 4.2 0 0 1-1.159-.37z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_8257_3126)",
    d: "M74.341 298.612q3.275-1.342 6.47-1.945l1.062-.003-5.798-2.783-1.062.003q-3.195.604-6.47 1.946a43 43 0 0 0-6.298 3.214 43 43 0 0 0-5.816 4.178q-2.745 2.284-4.812 4.795t-3.372 5.158q-1.317 2.6-1.536 5.124-.148 1.954.237 3.178.384 1.226 1.226 1.863.27.204.575.352l5.799 2.783a3.4 3.4 0 0 1-.575-.353q-.842-.637-1.227-1.862-.383-1.225-.236-3.178.217-2.526 1.536-5.124 1.304-2.647 3.372-5.158t4.811-4.795a43 43 0 0 1 5.816-4.179 43 43 0 0 1 6.298-3.214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M54.544 326.48q.65.315 1.466.381 1.188.047 2.597-.33a22 22 0 0 0 1.632-.588l-5.798-2.782a22 22 0 0 1-1.633.587q-1.41.378-2.596.33a4.1 4.1 0 0 1-1.467-.381zM60.244 325.94l1.993-.915-5.799-2.783-1.992.915z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M62.233 325.027q-.444-2.491-.423-4.709a11.8 11.8 0 0 1 .99-4.443q.984-2.176 3.192-4.374 2.194-2.247 6.174-4.72l-5.799-2.783q-3.98 2.473-6.174 4.72-2.208 2.199-3.19 4.374a11.8 11.8 0 0 0-.992 4.443q-.021 2.219.423 4.709z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M72.17 306.779q.217 3.727.665 8.533.45 4.805 1.16 9.759.75 4.883 1.77 9.319 1.071 4.412 2.468 7.327l-5.8-2.782q-1.395-2.916-2.466-7.328-1.02-4.435-1.77-9.318a198 198 0 0 1-1.16-9.76q-.45-4.806-.665-8.532z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M78.23 341.718q1.278.598 2.552.553a11.4 11.4 0 0 0 2.67-.471 16.5 16.5 0 0 0 2.705-.972 50 50 0 0 1 2.89-1.111l-5.798-2.783q-1.485.52-2.89 1.111a16.3 16.3 0 0 1-2.705.972q-1.347.402-2.67.471-1.274.046-2.553-.552zM89.055 339.713q.798-6.832 1.944-13.825 1.147-6.993 2.025-14.778l-5.799-2.783a298 298 0 0 1-2.024 14.778 302 302 0 0 0-1.945 13.826z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M93.019 311.113q.638 3.425 1.295 6.087.708 2.64 1.463 5.041a271 271 0 0 0 1.586 4.876 341 341 0 0 1 1.903 5.431q.385 1.144 1.174 1.548l-5.798-2.783q-.79-.404-1.174-1.547a340 340 0 0 0-1.903-5.432 268 268 0 0 1-1.587-4.876 123 123 0 0 1-1.462-5.04q-.657-2.662-1.296-6.088z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M100.443 334.095q.339.173.751.21 1.439.148 3.17-.485a22.5 22.5 0 0 0 3.599-1.598 93 93 0 0 1 3.136-1.655l-5.798-2.783a94 94 0 0 0-3.136 1.655 22.5 22.5 0 0 1-3.6 1.598q-1.73.633-3.17.485a2 2 0 0 1-.75-.209z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M111.096 330.567q.234-3.717.665-7.957.417-4.286 1.045-8.832.628-4.545 1.405-9.159a196 196 0 0 1 1.805-9.127 170 170 0 0 1 2.209-8.665q1.18-4.152 2.591-7.656l-5.799-2.783q-1.41 3.504-2.591 7.656a168 168 0 0 0-2.208 8.666 196 196 0 0 0-1.806 9.127 314 314 0 0 0-1.405 9.159 222 222 0 0 0-1.045 8.832 209 209 0 0 0-.664 7.957z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M120.814 279.174q-1.452-.411-3.099-.086a12.2 12.2 0 0 0-3.204.985 17.3 17.3 0 0 0-3.16 1.774 41 41 0 0 0-2.869 2.233l-5.799-2.783a41 41 0 0 1 2.869-2.233 17.3 17.3 0 0 1 3.161-1.774 12.2 12.2 0 0 1 3.203-.985q1.647-.325 3.1.086z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M103.47 320.488a125 125 0 0 1-.773-4.765 690 690 0 0 1-.719-5.813 375 375 0 0 1-.596-6.193 242 242 0 0 1-.47-5.927 835 835 0 0 1-.312-4.922 68 68 0 0 1-.076-3.414l-5.798-2.783q-.016 1.194.075 3.414.129 2.15.312 4.922.185 2.772.47 5.928.273 3.108.597 6.192.36 3.014.718 5.814.396 2.727.774 4.764z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m100.522 289.454-.034-.017-5.799-2.782.034.016z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M100.499 289.437q-.83-.405-1.906-.333-1.099.073-2.296.408-1.148.31-2.342.859-1.159.478-2.205.958l-5.798-2.782q1.046-.481 2.204-.958a15 15 0 0 1 2.343-.86 11.4 11.4 0 0 1 2.295-.407q1.078-.072 1.906.332z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M91.744 291.328q-.553 1.278-1.21 3.627a102 102 0 0 0-1.396 5.437 302 302 0 0 0-1.535 6.794q-.76 3.635-1.592 7.628a772 772 0 0 1-1.638 8.08q-.87 4.063-1.726 7.959l-5.799-2.782q.858-3.897 1.727-7.959.855-4.112 1.638-8.081l1.591-7.628a303 303 0 0 1 1.536-6.794q.726-3.135 1.395-5.436.658-2.35 1.21-3.627z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M108.481 284.081q-1.38 4.244-2.093 9.097a166 166 0 0 0-1.138 9.737 1508 1508 0 0 0-.729 9.388q-.354 4.527-1.05 8.188l-5.799-2.783q.697-3.661 1.05-8.188.34-4.575.73-9.387.424-4.883 1.137-9.737t2.093-9.098z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_8257_3126)",
    fillRule: "evenodd",
    d: "m138.867 226.787 20.212-9.277c4.463-2.048 9.211-2.268 13.199-.61s6.889 5.056 8.066 9.449l20.443 76.295c.584 2.179.726 4.538.416 6.94s-1.063 4.801-2.219 7.059a23.3 23.3 0 0 1-4.515 6.101c-1.825 1.769-3.906 3.199-6.121 4.209l-20.213 9.277c-3.272 1.508-6.728 2.025-9.93 1.486l-10.822-1.847-5.447 8.476c-2.301 3.541-5.521 6.392-9.173 8.121l-62.306 28.597c-2.21 1.014-4.512 1.59-6.777 1.695-2.264.105-4.446-.264-6.421-1.085a13.4 13.4 0 0 1-5.087-3.699c-1.384-1.621-2.397-3.575-2.98-5.75L28.75 295.929c-1.177-4.393-.533-9.419 1.79-13.973s6.137-8.264 10.6-10.313L103.544 243c3.675-1.656 7.557-2.063 11.039-1.158l8.349 2.145 7.47-10.243c2.243-3.038 5.189-5.459 8.464-6.957m-5.585 68.646c.977.165 2.032.008 3.032-.45 1.34-.615 2.485-1.729 3.183-3.097.697-1.368.891-2.877.537-4.196-.263-.984-.817-1.81-1.592-2.373-.774-.562-1.734-.838-2.758-.79s-2.067.415-2.996 1.056a6.96 6.96 0 0 0-2.223 2.549c-.52 1.02-.764 2.127-.7 3.182.063 1.054.431 2.008 1.057 2.741a4.1 4.1 0 0 0 2.46 1.378m12.905 18.787c.336-1.073.374-2.17.111-3.154-.354-1.319-1.225-2.34-2.423-2.838-1.197-.497-2.623-.431-3.963.184a6.74 6.74 0 0 0-2.583 2.126 6.7 6.7 0 0 0-1.263 3.087c-.139 1.084.029 2.13.482 3.006a4.08 4.08 0 0 0 2.066 1.911c.893.371 1.92.432 2.952.174 1.031-.258 2.021-.823 2.844-1.623a6.95 6.95 0 0 0 1.777-2.873m-19.169-42.163c.978.165 2.033.008 3.032-.45 1.34-.615 2.485-1.729 3.183-3.097s.891-2.877.538-4.196c-.264-.984-.818-1.81-1.592-2.373s-1.735-.838-2.759-.79-2.067.415-2.995 1.057a6.94 6.94 0 0 0-2.223 2.548c-.52 1.02-.764 2.127-.701 3.182.064 1.054.432 2.008 1.058 2.741a4.1 4.1 0 0 0 2.459 1.378m-50.94 21.826-1.062.003q-3.195.603-6.47 1.946-3.226 1.318-6.298 3.214a43 43 0 0 0-5.816 4.178q-2.744 2.283-4.812 4.795t-3.372 5.158q-1.317 2.598-1.535 5.124-.148 1.954.236 3.178.384 1.225 1.226 1.863.842.636 2.042.733 1.188.046 2.597-.33a22 22 0 0 0 1.632-.588l1.992-.914q-.444-2.491-.423-4.709.059-2.29.991-4.443.984-2.175 3.19-4.374 2.196-2.247 6.175-4.72.216 3.728.664 8.532.45 4.806 1.161 9.76.75 4.882 1.77 9.318 1.07 4.413 2.467 7.328 1.278.598 2.553.553a11.3 11.3 0 0 0 2.67-.472q1.359-.354 2.704-.971a50 50 0 0 1 2.89-1.111q.798-6.833 1.945-13.825 1.147-6.993 2.025-14.779.638 3.426 1.296 6.088.706 2.639 1.462 5.04a268 268 0 0 0 1.586 4.876 342 342 0 0 1 1.903 5.432q.55 1.633 1.925 1.757 1.438.148 3.17-.485a22.7 22.7 0 0 0 3.599-1.598 93 93 0 0 1 3.136-1.655q.234-3.718.665-7.957.417-4.287 1.045-8.833.627-4.545 1.405-9.159a196 196 0 0 1 1.805-9.127 169 169 0 0 1 2.209-8.665q1.18-4.152 2.591-7.656-1.453-.411-3.1-.086a12.2 12.2 0 0 0-3.203.985 17.3 17.3 0 0 0-3.161 1.774 41 41 0 0 0-2.869 2.233q-1.38 4.245-2.093 9.098a167 167 0 0 0-1.138 9.737q-.388 4.812-.729 9.387-.352 4.527-1.05 8.188-.378-2.036-.773-4.764a690 690 0 0 1-.719-5.814q-.322-3.084-.597-6.192-.285-3.156-.47-5.928a808 808 0 0 1-.311-4.922q-.092-2.22-.076-3.413-.84-.423-1.94-.35-1.098.074-2.295.407a15 15 0 0 0-2.343.86q-1.158.478-2.204.958-.552 1.276-1.21 3.627a102 102 0 0 0-1.395 5.436 302 302 0 0 0-1.536 6.794q-.76 3.636-1.591 7.628a772 772 0 0 1-1.639 8.081q-.869 4.062-1.726 7.959-.134-2.795-.297-6.115-.175-3.369-.363-6.785-.15-3.486-.327-6.855a250 250 0 0 1-.16-6.231 134 134 0 0 1 0-5.011q.096-2.146.376-3.191",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8257_3126)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1460.94 115.567c1.42 3.866 1.01 8.123-1.17 11.904l-39.49 68.405c-1.13 1.953-2.7 3.721-4.62 5.2-1.91 1.48-4.14 2.644-6.56 3.423-2.41.78-4.96 1.161-7.5 1.121-2.55-.039-5.03-.499-7.31-1.352l-20.85-7.732c-3.38-1.248-6.19-3.326-8.07-5.971l-6.35-8.959-2.13-6.067 6.34 8.958c1.89 2.645 4.7 4.723 8.08 5.971l20.85 7.732c2.28.853 4.76 1.313 7.3 1.352s5.1-.341 7.51-1.121c2.41-.779 4.64-1.943 6.56-3.422s3.49-3.248 4.61-5.201l39.5-68.405c2.18-3.781 2.59-8.038 1.16-11.904z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_8257_3126)",
    fillRule: "evenodd",
    d: "m1359.03 181.611-9.85 2.142c-4.13.877-8.42.616-12.23-.744l-64.27-23.836c-2.28-.845-4.32-2.066-6-3.593-1.67-1.528-2.95-3.331-3.77-5.308l-2.13-6.067c.81 1.976 2.1 3.78 3.77 5.307 1.68 1.527 3.71 2.748 5.99 3.594l64.28 23.835c3.8 1.36 8.1 1.621 12.23.745l9.84-2.143z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1262.68 149.673a13.2 13.2 0 0 1-.75-5.616c.16-2.125.83-4.222 1.95-6.172l39.5-68.405c2.27-3.938 6.28-7.037 11.14-8.615 4.87-1.577 10.19-1.504 14.79.203l64.38 23.874c3.77 1.428 6.81 3.886 8.63 6.988l4.38 7.42-2.13-6.068-4.39-7.42c-1.82-3.102-4.85-5.56-8.62-6.988L1327.18 55c-4.61-1.707-9.92-1.78-14.79-.202-4.86 1.577-8.87 4.676-11.14 8.614l-39.5 68.405c-1.12 1.95-1.79 4.047-1.96 6.172-.15 1.913.11 3.814.75 5.616zM1406.7 99.347l12.52-1.96c3.74-.562 7.53-.192 10.91 1.065l20.85 7.732c4.61 1.708 8.12 4.909 9.77 8.901l-2.14-6.067c-1.65-3.992-5.16-7.194-9.76-8.902L1428 92.384c-3.38-1.257-7.17-1.627-10.91-1.066l-12.52 1.961z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1388.28 138.875a4.43 4.43 0 0 0-1.22-1.843c-.76-.691-1.76-1.168-2.87-1.371a6.96 6.96 0 0 0-3.37.231c-1.09.353-2.05.964-2.75 1.754s-1.11 1.725-1.19 2.687c-.04.557.03 1.109.21 1.632l-2.14-6.068a4.1 4.1 0 0 1-.2-1.632c.07-.962.49-1.896 1.19-2.687s1.65-1.401 2.74-1.754a7 7 0 0 1 3.38-.231c1.11.203 2.11.68 2.86 1.371.58.525 1 1.156 1.23 1.843z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1377.09 141.967c.13.379.31.742.56 1.081.57.808 1.43 1.443 2.46 1.826 1.38.512 2.98.534 4.44.061s2.66-1.405 3.35-2.587c.51-.882.7-1.858.55-2.803-.04-.227-.09-.45-.17-.667l-2.13-6.068c.07.217.13.44.17.667.14.945-.05 1.921-.56 2.803-.68 1.183-1.88 2.113-3.34 2.587-1.46.473-3.06.452-4.44-.061-1.04-.382-1.89-1.018-2.47-1.825-.24-.34-.42-.703-.55-1.082zM1376.17 159.802c-.02-.073-.05-.145-.08-.217l-2.13-6.068c.03.072.06.144.08.217z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1376.09 159.584c-.5-1.198-1.55-2.16-2.93-2.673a6.74 6.74 0 0 0-3.33-.322 6.7 6.7 0 0 0-3.08 1.289c-.86.669-1.48 1.527-1.78 2.467-.28.864-.27 1.762.02 2.596l-2.13-6.068a4.1 4.1 0 0 1-.03-2.596c.3-.94.92-1.798 1.79-2.467.86-.668 1.93-1.117 3.07-1.289s2.3-.06 3.33.322c1.39.513 2.44 1.475 2.94 2.673z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1364.99 162.941.09.217-2.14-6.068c-.03-.072-.05-.144-.08-.216z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1365.08 163.158c.37.894 1.05 1.663 1.96 2.211.91.546 2.01.847 3.16.863a6.96 6.96 0 0 0 3.29-.775c.99-.521 1.8-1.27 2.31-2.152.64-1.111.77-2.36.37-3.502l-2.13-6.068c.4 1.142.27 2.391-.38 3.502-.5.882-1.31 1.631-2.3 2.152-1 .521-2.14.79-3.29.775s-2.25-.316-3.16-.863c-.91-.548-1.6-1.317-1.97-2.211z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1400.38 117.917a4.4 4.4 0 0 0-1.22-1.843c-.76-.691-1.76-1.168-2.87-1.371a6.94 6.94 0 0 0-3.37.23c-1.09.354-2.05.964-2.75 1.755s-1.11 1.725-1.19 2.686c-.04.558.03 1.109.21 1.632l-2.13-6.068a3.9 3.9 0 0 1-.21-1.632c.07-.961.49-1.896 1.19-2.686.7-.791 1.66-1.401 2.74-1.754a7 7 0 0 1 3.38-.231c1.11.203 2.11.68 2.86 1.371.58.525 1 1.155 1.23 1.843z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1389.19 121.005c.13.379.32.742.56 1.082.57.807 1.43 1.443 2.46 1.825 1.38.513 2.98.534 4.44.061s2.67-1.404 3.35-2.587c.51-.882.7-1.858.55-2.803-.04-.227-.09-.45-.16-.667l-2.14-6.068c.08.217.13.44.17.667.15.945-.05 1.921-.55 2.803-.69 1.183-1.89 2.113-3.35 2.587-1.46.473-3.06.452-4.44-.061-1.03-.382-1.89-1.018-2.46-1.825-.25-.34-.43-.703-.56-1.082z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear_8257_3126)",
    d: "M1331.59 97.548c2.17.912 4.16 1.978 5.95 3.199l.75.75-2.13-6.068-.76-.75c-1.79-1.22-3.77-2.287-5.95-3.199q-3.21-1.349-6.72-2.18a43 43 0 0 0-7.07-1.158c-2.37-.218-4.63-.221-6.79-.012q-3.24.314-6.03 1.263-2.775.906-4.71 2.537c-.99.851-1.69 1.656-2.08 2.415q-.6 1.137-.45 2.183.045.335.15.657l2.14 6.067a3 3 0 0 1-.16-.656q-.15-1.046.45-2.184c.4-.758 1.09-1.563 2.08-2.414q1.935-1.632 4.71-2.537 2.79-.95 6.03-1.263c2.16-.21 4.42-.206 6.79.012 2.39.188 4.75.574 7.07 1.158 2.34.554 4.58 1.281 6.73 2.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1297.88 103.254c.16.455.42.891.77 1.306q.81.873 2.07 1.603c.45.235.97.481 1.57.739l-2.13-6.068c-.6-.257-1.13-.504-1.57-.739-.85-.486-1.53-1.02-2.07-1.603-.36-.415-.61-.85-.77-1.306z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1302.3 106.903 2.05.762-2.13-6.068-2.06-.762z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1304.35 107.664q1.44-2.075 3.03-3.629a11.8 11.8 0 0 1 3.84-2.441c1.49-.562 3.27-.841 5.35-.836 2.09-.025 4.66.318 7.7 1.028l-2.13-6.068c-3.04-.71-5.61-1.053-7.7-1.028-2.08-.004-3.86.274-5.35.837a11.7 11.7 0 0 0-3.84 2.44c-1.06 1.036-2.07 2.246-3.04 3.629z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1324.28 101.788a248 248 0 0 0-5.57 6.503 202 202 0 0 0-6.08 7.722 124 124 0 0 0-5.33 7.84c-1.58 2.585-2.73 4.894-3.44 6.926l-2.13-6.068c.71-2.032 1.86-4.341 3.43-6.925q2.415-3.858 5.34-7.841c2-2.671 4.03-5.245 6.08-7.722s3.91-4.644 5.56-6.503z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1303.86 130.778q.48 1.327 1.41 2.196.99.888 2.22 1.555c.81.474 1.68.882 2.6 1.225.94.384 1.89.804 2.83 1.258l-2.13-6.068c-.95-.454-1.89-.874-2.83-1.258a16.3 16.3 0 0 1-2.6-1.225c-.82-.445-1.57-.963-2.22-1.555-.62-.579-1.1-1.311-1.42-2.196zM1312.93 137.015c3.6-2.845 7.31-5.645 11.15-8.401q5.76-4.134 11.88-9.018l-2.13-6.068a308 308 0 0 1-11.88 9.019 292 292 0 0 0-11.15 8.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1335.96 119.595a101 101 0 0 0-3.39 5.22 115 115 0 0 0-2.53 4.599c-.78 1.488-1.55 3.011-2.33 4.569-.72 1.543-1.56 3.271-2.49 5.186q-.54 1.081-.27 1.925l-2.13-6.068c-.18-.563-.09-1.204.26-1.924.94-1.916 1.77-3.644 2.5-5.187.77-1.558 1.55-3.081 2.32-4.569.78-1.488 1.62-3.021 2.53-4.599q1.425-2.347 3.39-5.22z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1324.95 141.095q.12.362.39.68c.6.747 1.47 1.38 2.58 1.898 1.13.559 2.36 1.031 3.67 1.415q1.98.576 3.39 1.047l-2.13-6.068q-1.41-.471-3.39-1.047a22.7 22.7 0 0 1-3.67-1.415c-1.12-.518-1.98-1.151-2.59-1.898-.17-.212-.3-.439-.38-.68zM1334.98 146.133c1.86-1.642 3.9-3.361 6.1-5.156 2.21-1.824 4.54-3.66 6.98-5.507q3.66-2.77 7.47-5.483c2.59-1.824 5.17-3.55 7.73-5.177 2.61-1.643 5.18-3.165 7.69-4.565a76 76 0 0 1 7.25-3.582l-2.14-6.068a77 77 0 0 0-7.24 3.582c-2.52 1.4-5.08 2.922-7.69 4.565a195 195 0 0 0-7.73 5.178 319 319 0 0 0-7.47 5.482 224 224 0 0 0-6.99 5.507 206 206 0 0 0-6.09 5.156z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1378.19 116.665q-.735-1.319-2.13-2.253a12.2 12.2 0 0 0-2.96-1.569 17.3 17.3 0 0 0-3.49-.98 41 41 0 0 0-3.61-.45l-2.13-6.068c1.19.095 2.4.245 3.61.45 1.25.219 2.41.545 3.49.981 1.09.406 2.08.929 2.96 1.568q1.395.935 2.13 2.253z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1336.72 133.614q1.17-1.708 2.82-3.916 1.725-2.233 3.6-4.619a335 335 0 0 1 3.96-4.801c1.35-1.622 2.64-3.13 3.86-4.523s2.3-2.627 3.26-3.701c1-1.09 1.79-1.913 2.36-2.467l-2.14-6.068c-.57.554-1.35 1.377-2.36 2.467-.95 1.074-2.04 2.308-3.26 3.701s-2.5 2.901-3.86 4.524a418 418 0 0 0-3.95 4.8c-1.25 1.591-2.45 3.13-3.61 4.619a138 138 0 0 0-2.82 3.916z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1356.58 109.585c-.01-.012-.01-.024-.02-.036l-2.13-6.068c0 .012.01.024.01.036z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1356.57 109.557q-.3-.872-1.11-1.583a11.3 11.3 0 0 0-1.91-1.336c-.69-.394-1.44-.744-2.27-1.048-.77-.321-1.51-.615-2.23-.882l-2.14-6.067c.72.266 1.47.56 2.24.88.82.306 1.58.655 2.26 1.049.73.407 1.36.853 1.92 1.336q.81.71 1.11 1.583z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1349.04 104.703q-1.29.512-3.42 1.709-2.1 1.153-4.83 2.857c-1.8 1.107-3.77 2.347-5.89 3.718-2.07 1.356-4.24 2.779-6.52 4.269a792 792 0 0 1-6.87 4.555 1167 1167 0 0 1-6.85 4.407l-2.13-6.067c2.24-1.433 4.52-2.902 6.85-4.408q3.51-2.302 6.87-4.555c2.27-1.49 4.45-2.913 6.52-4.268 2.12-1.372 4.08-2.612 5.89-3.719a102 102 0 0 1 4.83-2.857q2.13-1.196 3.42-1.71z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1366 111.413c-2.65 1.35-5.29 3.001-7.91 4.953a168 168 0 0 0-7.69 6.08 1301 1301 0 0 0-7.15 6.123q-3.45 2.951-6.54 5.047l-2.13-6.068c2.06-1.397 4.23-3.079 6.53-5.047 2.32-1.996 4.71-4.037 7.16-6.122 2.5-2.102 5.06-4.129 7.69-6.081 2.62-1.952 5.26-3.603 7.91-4.953z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear_8257_3126)",
    fillRule: "evenodd",
    d: "m1428 92.387 20.85 7.732c4.61 1.707 8.12 4.909 9.77 8.901s1.29 8.447-.98 12.386l-39.49 68.404c-1.13 1.954-2.7 3.721-4.62 5.201-1.91 1.48-4.14 2.643-6.56 3.422-2.41.78-4.96 1.161-7.5 1.122-2.55-.04-5.03-.499-7.31-1.352l-20.85-7.733c-3.38-1.247-6.19-3.326-8.07-5.971l-6.35-8.958-9.84 2.142c-4.14.877-8.43.616-12.23-.745l-64.28-23.835c-2.28-.845-4.32-2.066-5.99-3.594-1.68-1.527-2.96-3.33-3.78-5.307a13.6 13.6 0 0 1-.98-6.213c.17-2.125.84-4.222 1.96-6.172l39.5-68.405c2.27-3.938 6.28-7.037 11.14-8.614 4.87-1.578 10.18-1.505 14.79.202l64.38 23.874c3.77 1.428 6.8 3.886 8.63 6.988l4.38 7.42 12.53-1.961c3.73-.562 7.53-.19 10.9 1.066m-52.49 44.59c.58.808 1.43 1.444 2.46 1.826 1.39.512 2.98.534 4.44.061s2.67-1.405 3.35-2.587c.51-.882.7-1.858.55-2.803-.15-.946-.63-1.82-1.39-2.51-.76-.691-1.75-1.168-2.86-1.371a7 7 0 0 0-3.38.23c-1.09.354-2.04.964-2.74 1.755s-1.12 1.725-1.19 2.686c-.08.961.19 1.905.76 2.713m-4.16 22.41c1-.521 1.8-1.27 2.31-2.152.68-1.182.79-2.52.3-3.719-.5-1.199-1.55-2.161-2.94-2.673a6.73 6.73 0 0 0-3.33-.323c-1.14.172-2.21.621-3.07 1.289-.87.669-1.49 1.527-1.79 2.467-.29.94-.26 1.918.11 2.812s1.05 1.663 1.97 2.211c.91.546 2.01.847 3.15.862 1.15.016 2.3-.254 3.29-.774m16.26-43.368c.58.808 1.43 1.443 2.46 1.825 1.39.513 2.98.535 4.44.061 1.47-.474 2.67-1.404 3.35-2.587.51-.882.7-1.857.55-2.803s-.63-1.819-1.39-2.51-1.75-1.168-2.86-1.37a7 7 0 0 0-3.38.23c-1.09.353-2.04.964-2.74 1.754-.7.791-1.12 1.725-1.19 2.687-.08.961.19 1.905.76 2.713m-51.45-20.587-.75-.749c-1.79-1.221-3.78-2.287-5.96-3.199q-3.21-1.35-6.72-2.18a43 43 0 0 0-7.07-1.159c-2.37-.217-4.63-.22-6.79-.011q-3.24.314-6.03 1.263-2.775.905-4.71 2.537c-.99.851-1.69 1.656-2.08 2.414q-.6 1.138-.45 2.184c.09.697.4 1.352.92 1.962q.81.874 2.07 1.603c.45.236.97.482 1.57.739l2.06.762q1.44-2.075 3.03-3.629a11.9 11.9 0 0 1 3.84-2.44c1.49-.563 3.27-.842 5.35-.837 2.09-.025 4.66.318 7.7 1.028a249 249 0 0 0-5.56 6.503 202 202 0 0 0-6.08 7.722 128 128 0 0 0-5.34 7.84c-1.57 2.585-2.72 4.893-3.44 6.926.33.885.8 1.617 1.42 2.196q.99.888 2.22 1.555c.81.474 1.67.882 2.6 1.225.94.384 1.89.804 2.83 1.258 3.6-2.845 7.31-5.645 11.15-8.401q5.76-4.134 11.88-9.018a116 116 0 0 0-3.39 5.221c-.91 1.577-1.75 3.11-2.53 4.598-.77 1.488-1.55 3.012-2.32 4.57-.73 1.542-1.56 3.271-2.5 5.186q-.765 1.544.12 2.603c.61.748 1.47 1.381 2.59 1.899 1.13.559 2.35 1.031 3.67 1.415q1.98.576 3.39 1.047a206 206 0 0 1 6.09-5.156q3.33-2.736 6.99-5.507t7.47-5.482c2.59-1.825 5.17-3.551 7.73-5.178 2.61-1.643 5.17-3.165 7.69-4.565a77 77 0 0 1 7.24-3.582q-.735-1.317-2.13-2.252c-.88-.64-1.86-1.162-2.96-1.569a17.2 17.2 0 0 0-3.49-.98 40 40 0 0 0-3.61-.45c-2.65 1.35-5.29 3.001-7.91 4.953a168 168 0 0 0-7.69 6.08 1301 1301 0 0 0-7.15 6.123c-2.3 1.967-4.48 3.65-6.53 5.047a121 121 0 0 1 2.82-3.916q1.725-2.232 3.6-4.619 1.95-2.409 3.96-4.8a237 237 0 0 1 3.86-4.524c1.22-1.393 2.3-2.627 3.26-3.701 1-1.09 1.79-1.912 2.36-2.467-.2-.596-.58-1.135-1.13-1.619-.55-.483-1.19-.928-1.91-1.335-.69-.394-1.44-.744-2.26-1.049-.77-.32-1.52-.614-2.24-.881q-1.29.513-3.42 1.709-2.1 1.153-4.83 2.857c-1.8 1.107-3.77 2.347-5.89 3.719-2.07 1.355-4.25 2.778-6.52 4.268a792 792 0 0 1-6.87 4.555 1743 1743 0 0 1-6.85 4.408c1.25-1.381 2.63-2.892 4.11-4.534 1.51-1.67 3.02-3.355 4.54-5.054a531 531 0 0 0 4.62-5.079 267 267 0 0 1 4.29-4.519c1.34-1.383 2.52-2.565 3.55-3.544q1.575-1.449 2.52-1.99",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8257_3126)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1378.28 255.597c2.03.348 3.77 1.591 4.86 3.481l19.75 34.202c.56.977.93 2.098 1.09 3.298.17 1.2.11 2.456-.15 3.697-.27 1.24-.74 2.44-1.4 3.53a10.9 10.9 0 0 1-2.41 2.825l-8.56 7.097c-1.38 1.151-2.99 1.848-4.6 2.002l-5.47.509-3.16-.594 5.47-.508c1.61-.155 3.22-.852 4.6-2.003l8.56-7.096c.94-.775 1.76-1.735 2.41-2.825a11.6 11.6 0 0 0 1.4-3.531c.26-1.24.31-2.496.15-3.697-.16-1.2-.53-2.321-1.1-3.297l-19.74-34.203c-1.09-1.89-2.83-3.132-4.87-3.481z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear_8257_3126)",
    fillRule: "evenodd",
    d: "m1381.4 316.236-1.54 4.799c-.65 2.008-1.84 3.801-3.38 5.109l-26.39 21.874a9.1 9.1 0 0 1-3.05 1.696 7.44 7.44 0 0 1-3.24.307l-3.16-.594a7.4 7.4 0 0 0 3.24-.307 9.1 9.1 0 0 0 3.05-1.696l26.39-21.874c1.54-1.307 2.73-3.101 3.38-5.109l1.54-4.798z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1343.48 349.972a6.7 6.7 0 0 1-2.62-1.078 7.3 7.3 0 0 1-2.18-2.392l-19.75-34.202c-1.14-1.969-1.48-4.48-.94-6.98.53-2.501 1.89-4.786 3.78-6.352l26.43-21.91c1.56-1.275 3.39-1.974 5.19-1.988l4.31-.045-3.17-.593-4.3.045c-1.8.013-3.63.712-5.19 1.987l-26.43 21.91c-1.89 1.567-3.25 3.852-3.78 6.352-.54 2.5-.2 5.011.94 6.98l19.75 34.203c.56.975 1.3 1.787 2.18 2.391.79.544 1.68.909 2.62 1.079z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1357.69 275.027 2.29-5.914c.69-1.757 1.8-3.308 3.18-4.455l8.56-7.096c1.89-1.567 4.16-2.287 6.3-2.003l-3.16-.593c-2.14-.285-4.41.436-6.3 2.003l-8.56 7.096c-1.39 1.147-2.49 2.697-3.19 4.455l-2.28 5.913z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint28_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1370.21 292.884a2.2 2.2 0 0 0-1.11.07c-.49.156-.94.468-1.31.898-.36.431-.62.959-.74 1.519s-.1 1.126.07 1.627.47.914.87 1.187q.345.239.75.319l-3.16-.594q-.405-.08-.75-.318c-.4-.273-.7-.686-.87-1.187a3.1 3.1 0 0 1-.07-1.627c.12-.56.38-1.089.74-1.519.37-.43.82-.743 1.31-.898.37-.118.75-.142 1.11-.071z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1368.75 298.504c.19.038.4.048.6.029.5-.047.99-.259 1.41-.61.57-.471.98-1.157 1.14-1.908s.05-1.504-.29-2.096a2.13 2.13 0 0 0-1.07-.94 2 2 0 0 0-.33-.095l-3.16-.594q.165.035.33.096c.44.172.82.499 1.07.94.34.591.45 1.345.29 2.096a3.4 3.4 0 0 1-1.14 1.907c-.42.351-.91.563-1.41.61-.2.02-.41.01-.61-.028zM1376.24 303.359l-.11-.018-3.17-.594q.06.007.12.019z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint29_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1376.12 303.341c-.64-.085-1.32.131-1.89.602-.42.35-.76.824-.97 1.361s-.28 1.112-.21 1.654.29 1.025.62 1.389c.31.335.7.555 1.13.638l-3.16-.594a2.06 2.06 0 0 1-1.13-.637 2.55 2.55 0 0 1-.62-1.39c-.07-.541 0-1.117.21-1.654s.55-1.01.97-1.361c.57-.47 1.25-.687 1.89-.601z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m1374.8 308.985.12.018-3.16-.593-.12-.019zM1374.92 309.003c.48.063.98-.04 1.45-.299.46-.258.87-.658 1.16-1.151s.46-1.056.49-1.618c.02-.561-.1-1.096-.36-1.537-.32-.556-.83-.926-1.42-1.039l-3.16-.593c.59.113 1.1.482 1.42 1.038.26.441.38.976.36 1.538-.03.561-.2 1.124-.49 1.617s-.7.894-1.16 1.152c-.47.258-.97.362-1.45.298z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint30_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1364.15 282.404a2.2 2.2 0 0 0-1.1.071c-.49.155-.94.468-1.31.898s-.62.959-.74 1.519-.1 1.126.07 1.627.47.914.87 1.187q.345.239.75.318l-3.16-.593q-.405-.08-.75-.319c-.4-.273-.7-.686-.87-1.187a3.1 3.1 0 0 1-.07-1.627c.12-.56.37-1.088.74-1.519s.82-.742 1.31-.898c.37-.118.75-.141 1.1-.07z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1362.69 288.023c.2.038.41.048.61.029.5-.047.99-.259 1.41-.61.57-.471.97-1.157 1.13-1.908s.06-1.504-.28-2.096a2.13 2.13 0 0 0-1.07-.94 2 2 0 0 0-.33-.095l-3.16-.593q.165.033.33.095c.44.172.82.499 1.07.94.34.591.44 1.345.28 2.096s-.56 1.437-1.13 1.907c-.43.351-.91.564-1.41.61-.21.02-.41.01-.61-.028z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint31_linear_8257_3126)",
    d: "M1338.14 307.102c.94-.714 1.89-1.307 2.87-1.777l.51-.138-3.16-.594-.51.139c-.98.47-1.93 1.062-2.87 1.777-.93.703-1.8 1.492-2.63 2.367-.83.861-1.59 1.784-2.27 2.771a18.6 18.6 0 0 0-1.7 2.938q-.675 1.48-.96 2.928c-.2.95-.23 1.841-.08 2.673.12.642.3 1.143.52 1.504q.345.543.84.741c.1.043.21.075.32.096l3.16.593a1.6 1.6 0 0 1-.32-.095c-.33-.133-.61-.38-.83-.741-.23-.361-.41-.863-.53-1.504-.15-.832-.12-1.723.08-2.674q.285-1.446.96-2.927c.45-.987 1.02-1.967 1.7-2.939.68-.986 1.44-1.91 2.27-2.77.83-.876 1.7-1.665 2.63-2.368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1332.18 323.123c.24.045.49.043.76-.006.39-.087.79-.252 1.21-.495.21-.135.45-.3.71-.495l-3.16-.594c-.26.196-.5.361-.71.495a4.4 4.4 0 0 1-1.21.495c-.27.05-.52.052-.76.006zM1334.86 322.124l.85-.699-3.16-.594-.85.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1335.71 321.426c-.36-.763-.63-1.503-.82-2.219q-.27-1.114-.09-2.274c.13-.786.45-1.627.97-2.526q.765-1.369 2.37-3.078l-3.16-.594q-1.605 1.71-2.37 3.079c-.52.898-.85 1.74-.97 2.525q-.18 1.161.09 2.274c.19.716.46 1.456.82 2.22z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint32_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1338.15 311.327c.39 1.182.86 2.526 1.42 4.035s1.17 3.03 1.82 4.563a69 69 0 0 0 2.06 4.272c.73 1.328 1.44 2.401 2.14 3.22l-3.16-.594c-.7-.818-1.41-1.891-2.14-3.22a69 69 0 0 1-2.06-4.271c-.65-1.534-1.26-3.055-1.82-4.563-.56-1.509-1.03-2.854-1.43-4.035z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1345.59 327.417c.47.083.9.061 1.31-.063a5.8 5.8 0 0 0 1.23-.573c.4-.232.8-.505 1.18-.82.4-.312.82-.615 1.25-.91l-3.16-.594c-.44.295-.85.599-1.25.911-.38.315-.78.588-1.19.819-.39.246-.8.437-1.22.573-.41.125-.84.146-1.31.064zM1350.56 325.048c-.33-2.269-.61-4.578-.85-6.929q-.345-3.526-.93-7.399l-3.16-.594c.38 2.583.7 5.049.93 7.4s.52 4.66.85 6.928z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint33_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1348.77 310.722c.51 1.048.98 1.972 1.42 2.772.45.789.91 1.537 1.36 2.246.45.708.91 1.424 1.39 2.149.49.699 1.03 1.492 1.63 2.377.22.335.47.534.76.595l-3.16-.593c-.29-.062-.54-.26-.76-.595-.6-.886-1.14-1.678-1.63-2.377-.48-.725-.94-1.442-1.39-2.15s-.91-1.456-1.36-2.245c-.44-.801-.91-1.725-1.42-2.773z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1355.33 320.861q.195.04.39.005.72-.115 1.47-.645.795-.526 1.53-1.237c.5-.475.93-.877 1.3-1.206l-3.16-.593c-.37.329-.8.731-1.3 1.205q-.735.711-1.53 1.238-.75.53-1.47.644-.195.036-.39-.004z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1360.02 317.778c-.24-1.217-.48-2.526-.71-3.928a123 123 0 0 1-.63-4.401q-.285-2.277-.51-4.606a95 95 0 0 1-.31-4.641 75 75 0 0 1-.05-4.471c.02-1.439.1-2.783.26-4.033l-3.16-.593c-.16 1.249-.24 2.594-.27 4.032q-.03 2.158.06 4.471c.06 1.516.17 3.063.31 4.642q.225 2.329.51 4.605t.63 4.401c.23 1.402.47 2.712.71 3.929z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint34_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1358.07 291.7a3.3 3.3 0 0 0-1.51.359c-.5.221-.97.518-1.42.891-.46.359-.89.78-1.3 1.266-.39.473-.76.956-1.1 1.449l-3.16-.593c.34-.493.71-.977 1.1-1.45a8.8 8.8 0 0 1 1.3-1.266c.45-.373.92-.669 1.42-.89.5-.247 1-.367 1.51-.36z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1355.03 313.897q-.435-.934-.99-2.201c-.35-.87-.72-1.775-1.09-2.714-.37-.965-.74-1.937-1.09-2.914-.37-.991-.7-1.925-1-2.802-.3-.876-.56-1.655-.79-2.336-.22-.708-.38-1.254-.47-1.639l-3.16-.594c.09.385.25.932.47 1.639.23.681.49 1.46.79 2.337.3.876.63 1.81 1 2.802q.525 1.465 1.08 2.913c.38.94.75 1.845 1.1 2.715q.555 1.266.99 2.201z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M1349.6 299.291c-.01-.001-.02-.002-.02-.004l-3.16-.593c0 .001.01.002.01.004z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint35_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1349.58 299.286q-.45-.088-.96.086c-.35.118-.7.283-1.06.494q-.51.298-1.02.718c-.33.254-.64.503-.94.748l-3.16-.594c.3-.245.61-.494.94-.748q.51-.419 1.02-.718c.36-.211.71-.375 1.06-.494q.51-.173.96-.086z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint36_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1345.6 301.332q-.105.688-.12 1.909-.015 1.197.03 2.806c.03 1.058.08 2.218.14 3.48.07 1.236.14 2.533.22 3.89.09 1.345.17 2.717.25 4.114.07 1.383.14 2.739.2 4.068l-3.16-.594c-.06-1.328-.13-2.684-.2-4.067-.08-1.398-.16-2.769-.25-4.115-.08-1.357-.15-2.654-.22-3.89-.06-1.262-.11-2.422-.14-3.48q-.045-1.608-.03-2.806.015-1.22.12-1.908z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint37_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M1352.74 295.666a28.5 28.5 0 0 0 .17 4.664c.19 1.625.43 3.242.71 4.85.29 1.583.58 3.126.86 4.628.28 1.489.46 2.852.56 4.091l-3.16-.594c-.1-1.239-.28-2.602-.56-4.09-.28-1.502-.57-3.045-.86-4.628a88 88 0 0 1-.71-4.85 27.5 27.5 0 0 1-.17-4.665z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint38_linear_8257_3126)",
    fillRule: "evenodd",
    d: "m1360 264.063 8.57-7.097c1.89-1.566 4.15-2.287 6.29-2.002 2.14.284 3.98 1.55 5.12 3.519l19.75 34.203c.56.977.93 2.097 1.1 3.297.16 1.201.1 2.457-.16 3.697-.27 1.24-.74 2.44-1.39 3.531-.66 1.09-1.48 2.05-2.42 2.825l-8.56 7.096c-1.38 1.151-2.98 1.848-4.6 2.003l-5.47.508-1.53 4.799c-.65 2.008-1.84 3.801-3.38 5.109l-26.39 21.874c-.94.776-1.97 1.352-3.05 1.696a7.46 7.46 0 0 1-3.24.307 6.75 6.75 0 0 1-2.94-1.128 7.3 7.3 0 0 1-2.18-2.392l-19.75-34.202c-1.14-1.969-1.48-4.48-.94-6.98.53-2.501 1.89-4.786 3.78-6.352l26.43-21.91c1.56-1.275 3.39-1.974 5.19-1.988l4.31-.045 2.28-5.913c.69-1.758 1.8-3.308 3.18-4.455m6.19 33.876c.49-.047.98-.259 1.41-.61.56-.47.97-1.157 1.13-1.907.16-.751.06-1.505-.28-2.097a2.1 2.1 0 0 0-1.08-.939 2.13 2.13 0 0 0-1.43-.025c-.49.155-.94.468-1.31.898s-.62.958-.74 1.518-.1 1.127.07 1.628.47.914.86 1.187c.4.273.88.394 1.37.347m8.66 7.403c.03-.561-.1-1.096-.35-1.537-.34-.592-.89-.972-1.54-1.057-.64-.086-1.32.131-1.89.601-.42.351-.76.825-.97 1.361-.21.537-.28 1.113-.21 1.654.07.542.29 1.026.62 1.39s.77.592 1.25.656c.48.063.98-.04 1.44-.298.47-.259.87-.659 1.17-1.152.29-.493.46-1.056.48-1.618m-14.71-17.882c.49-.047.98-.259 1.41-.61.56-.471.97-1.157 1.13-1.908s.06-1.504-.28-2.096a2.1 2.1 0 0 0-1.08-.94c-.44-.171-.94-.18-1.43-.025-.49.156-.95.468-1.31.899-.37.43-.62.958-.74 1.518s-.1 1.126.07 1.627.47.914.86 1.188c.4.273.88.393 1.37.347m-21.78 17.133-.51.139c-.98.47-1.93 1.062-2.87 1.777-.93.703-1.8 1.492-2.63 2.367-.83.861-1.59 1.784-2.27 2.771a18.6 18.6 0 0 0-1.7 2.938q-.675 1.48-.96 2.928c-.2.95-.23 1.841-.08 2.673.12.642.3 1.143.53 1.505s.5.608.83.74a1.9 1.9 0 0 0 1.08.09c.39-.087.79-.252 1.21-.495.22-.135.45-.3.71-.495l.85-.7c-.36-.763-.63-1.503-.82-2.219-.17-.743-.21-1.5-.09-2.274.13-.786.45-1.627.97-2.526q.78-1.369 2.37-3.078c.39 1.181.87 2.526 1.43 4.035.56 1.508 1.17 3.029 1.82 4.563a64 64 0 0 0 2.06 4.271c.73 1.329 1.44 2.402 2.14 3.22.47.083.9.061 1.31-.063q.63-.205 1.23-.574c.4-.231.8-.504 1.18-.819.4-.312.82-.615 1.25-.91-.33-2.269-.62-4.579-.85-6.929-.24-2.35-.55-4.817-.94-7.399.5 1.047.98 1.971 1.42 2.772.45.789.91 1.537 1.36 2.245s.91 1.425 1.39 2.15q.735 1.048 1.62 2.377c.32.478.71.678 1.16.599q.72-.114 1.47-.644a10.7 10.7 0 0 0 1.53-1.238c.5-.474.93-.876 1.3-1.205-.24-1.217-.48-2.527-.71-3.929-.23-1.416-.45-2.883-.63-4.401q-.285-2.276-.51-4.605a95 95 0 0 1-.31-4.642 85 85 0 0 1-.06-4.471c.03-1.438.11-2.783.27-4.032a3.26 3.26 0 0 0-1.51.359c-.5.221-.97.518-1.42.891-.46.358-.89.78-1.3 1.265-.39.474-.76.957-1.1 1.45-.07 1.486-.02 3.04.17 4.665s.43 3.241.71 4.85c.29 1.583.58 3.125.86 4.628.28 1.488.46 2.851.56 4.09q-.45-.935-.99-2.201c-.36-.87-.73-1.775-1.1-2.715-.37-.965-.74-1.936-1.09-2.913-.37-.991-.7-1.925-1-2.802q-.45-1.316-.78-2.337-.345-1.06-.48-1.639a1.84 1.84 0 0 0-.98.082c-.35.119-.7.283-1.06.494q-.51.299-1.02.718c-.33.254-.65.504-.94.748q-.105.688-.12 1.909-.015 1.198.03 2.806c.03 1.057.08 2.217.14 3.48.07 1.236.14 2.533.22 3.89.09 1.345.17 2.717.25 4.114.07 1.383.14 2.739.2 4.068-.28-.889-.6-1.86-.93-2.915-.35-1.07-.7-2.146-1.06-3.23-.35-1.11-.7-2.199-1.04-3.268-.34-1.081-.63-2.078-.89-2.989-.26-.926-.48-1.733-.65-2.42-.15-.7-.23-1.229-.23-1.59",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_8257_3126)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint39_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M133.467 123.784c.714 1.933.509 4.062-.583 5.952l-19.746 34.202a9 9 0 0 1-2.307 2.601 10.8 10.8 0 0 1-3.281 1.711c-1.206.39-2.482.58-3.753.561-1.27-.02-2.512-.25-3.652-.676l-10.426-3.867c-1.69-.623-3.095-1.663-4.036-2.985l-3.174-4.479-1.066-3.034 3.174 4.479c.941 1.322 2.346 2.362 4.035 2.985l10.427 3.867a11 11 0 0 0 3.652.676 11.7 11.7 0 0 0 3.753-.561 10.8 10.8 0 0 0 3.281-1.711 9 9 0 0 0 2.306-2.601l19.747-34.202c1.091-1.89 1.297-4.019.583-5.952z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint40_linear_8257_3126)",
    fillRule: "evenodd",
    d: "m82.513 156.806-4.922 1.071c-2.066.438-4.213.308-6.115-.372l-32.139-11.918a9.2 9.2 0 0 1-2.995-1.797 7.44 7.44 0 0 1-1.887-2.654l-1.066-3.033a7.4 7.4 0 0 0 1.886 2.653 9.2 9.2 0 0 0 2.996 1.797l32.139 11.918c1.902.68 4.049.81 6.114.372l4.922-1.071z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M34.339 140.837a6.7 6.7 0 0 1-.376-2.808 7.3 7.3 0 0 1 .98-3.086L54.69 100.74c1.136-1.969 3.141-3.518 5.573-4.307s5.091-.752 7.393.101l32.191 11.937c1.885.714 3.401 1.943 4.312 3.494l2.194 3.71-1.066-3.034-2.194-3.71c-.911-1.551-2.428-2.78-4.312-3.494L66.59 93.5c-2.302-.853-4.962-.89-7.393-.101s-4.437 2.338-5.574 4.307L33.877 131.91a7.3 7.3 0 0 0-.98 3.086 6.7 6.7 0 0 0 .376 2.808z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m106.35 115.673 6.262-.98c1.868-.281 3.765-.095 5.452.533l10.427 3.866c2.302.854 4.058 2.455 4.882 4.451l-1.067-3.034c-.824-1.996-2.58-3.597-4.882-4.451l-10.426-3.866c-1.687-.628-3.585-.814-5.452-.533l-6.262.98z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint41_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M97.142 135.438a2.2 2.2 0 0 0-.614-.922 2.9 2.9 0 0 0-1.432-.685 3.5 3.5 0 0 0-1.687.115 3.1 3.1 0 0 0-1.373.877c-.35.395-.557.863-.595 1.344-.022.278.013.554.103.816l-1.066-3.034a2 2 0 0 1-.103-.816 2.3 2.3 0 0 1 .595-1.344c.35-.395.828-.7 1.372-.877a3.5 3.5 0 0 1 1.687-.115c.556.101 1.054.34 1.433.685.288.263.497.578.613.922z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M91.544 136.984q.097.284.279.54c.287.404.716.722 1.231.913.691.256 1.49.267 2.22.03s1.332-.702 1.674-1.293c.255-.441.35-.929.276-1.402a2 2 0 0 0-.083-.333l-1.066-3.034q.056.163.083.333c.074.473-.022.961-.276 1.402-.342.591-.944 1.056-1.674 1.293a3.42 3.42 0 0 1-2.22-.03 2.6 2.6 0 0 1-1.231-.913 2.1 2.1 0 0 1-.28-.54zM91.087 145.901l-.041-.108-1.067-3.034q.023.054.042.108z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint42_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M91.045 145.792c-.247-.599-.775-1.08-1.466-1.336a3.36 3.36 0 0 0-1.665-.161c-.57.086-1.105.31-1.538.644a2.56 2.56 0 0 0-.892 1.233c-.137.432-.132.881.013 1.298l-1.066-3.034a2.04 2.04 0 0 1-.013-1.298c.149-.469.46-.899.892-1.233a3.34 3.34 0 0 1 1.538-.644 3.36 3.36 0 0 1 1.665.161c.69.256 1.218.737 1.466 1.336z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M85.497 147.471q.019.054.041.108l-1.066-3.034-.041-.108zM85.539 147.579c.184.447.526.832.982 1.106a3.17 3.17 0 0 0 1.58.431 3.5 3.5 0 0 0 1.643-.387c.499-.261.9-.635 1.155-1.076.32-.556.386-1.18.188-1.751l-1.066-3.034c.198.571.132 1.195-.189 1.751a2.84 2.84 0 0 1-1.154 1.076 3.5 3.5 0 0 1-1.644.387 3.17 3.17 0 0 1-1.58-.431 2.35 2.35 0 0 1-.981-1.106z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint43_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M103.192 124.958a2.2 2.2 0 0 0-.614-.921 2.9 2.9 0 0 0-1.433-.686 3.5 3.5 0 0 0-1.687.116 3.1 3.1 0 0 0-1.372.877c-.35.395-.557.862-.595 1.343-.022.279.013.555.103.816l-1.066-3.034a2 2 0 0 1-.104-.816c.038-.481.245-.948.596-1.343.35-.395.828-.701 1.372-.877a3.47 3.47 0 0 1 1.687-.115 2.9 2.9 0 0 1 1.433.685c.288.262.497.578.613.921z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M97.596 126.503q.098.285.279.54c.287.404.715.722 1.23.913.692.256 1.491.267 2.221.03s1.332-.702 1.674-1.293c.254-.441.35-.929.276-1.402a2 2 0 0 0-.083-.333l-1.066-3.034a2 2 0 0 1 .082.333c.075.473-.021.961-.276 1.402-.341.591-.943 1.057-1.673 1.293-.73.237-1.53.226-2.22-.03a2.6 2.6 0 0 1-1.232-.913 2.1 2.1 0 0 1-.279-.54z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint44_linear_8257_3126)",
    d: "M68.794 114.774q1.632.684 2.975 1.6l.376.375-1.066-3.034-.376-.375a16.7 16.7 0 0 0-2.976-1.6 21.5 21.5 0 0 0-3.363-1.09 21.4 21.4 0 0 0-3.533-.579 18 18 0 0 0-3.397-.006q-1.619.157-3.016.632-1.384.453-2.354 1.268-.743.638-1.04 1.208-.297.569-.225 1.091.023.168.079.329l1.066 3.033a1.7 1.7 0 0 1-.079-.328q-.072-.522.225-1.092.297-.568 1.04-1.207.97-.815 2.355-1.268a13.3 13.3 0 0 1 3.016-.632 18 18 0 0 1 3.396.006q1.79.141 3.533.579 1.756.416 3.364 1.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M51.941 117.627q.12.342.384.653.403.437 1.035.802.335.175.785.369l-1.067-3.034q-.45-.193-.785-.369a4.4 4.4 0 0 1-1.034-.802 2 2 0 0 1-.384-.653zM54.148 119.451l1.028.381-1.066-3.033-1.028-.382z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M55.173 119.832q.724-1.037 1.515-1.814a5.9 5.9 0 0 1 1.922-1.221q1.117-.421 2.674-.418 1.57-.019 3.852.514l-1.066-3.034q-2.281-.532-3.852-.514-1.558-.003-2.675.418a5.9 5.9 0 0 0-1.92 1.221 13 13 0 0 0-1.516 1.814z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint45_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M65.139 116.894a121 121 0 0 0-2.782 3.252 99 99 0 0 0-3.04 3.86 64 64 0 0 0-2.669 3.921q-1.181 1.938-1.719 3.463l-1.066-3.034q.537-1.525 1.719-3.463a64 64 0 0 1 2.669-3.92q1.5-2.004 3.04-3.861a121 121 0 0 1 2.782-3.252z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M54.929 131.389q.24.663.707 1.098a5.7 5.7 0 0 0 1.11.777q.607.355 1.3.613.707.288 1.415.629l-1.066-3.034a25 25 0 0 0-1.415-.629 8.3 8.3 0 0 1-1.3-.612 5.7 5.7 0 0 1-1.11-.778 2.75 2.75 0 0 1-.708-1.098zM59.465 134.508a150 150 0 0 1 5.575-4.201 149 149 0 0 0 5.941-4.509l-1.066-3.034a149 149 0 0 1-5.941 4.51 149 149 0 0 0-5.576 4.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint46_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M70.978 125.798a54 54 0 0 0-1.694 2.61 62 62 0 0 0-1.265 2.299 135 135 0 0 0-1.163 2.285q-.543 1.156-1.248 2.593-.269.54-.132.962l-1.066-3.034q-.136-.422.132-.962.704-1.437 1.247-2.593.582-1.169 1.163-2.285.583-1.116 1.266-2.299a54 54 0 0 1 1.694-2.61z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M65.477 136.548q.059.18.191.34.456.56 1.292.949.85.419 1.838.707t1.694.524l-1.066-3.034a47 47 0 0 0-1.694-.524 11.3 11.3 0 0 1-1.838-.707q-.836-.389-1.292-.949a1 1 0 0 1-.191-.34z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M70.49 139.067q1.398-1.233 3.048-2.579a110 110 0 0 1 3.492-2.753q1.83-1.385 3.735-2.741a98 98 0 0 1 3.865-2.589 85 85 0 0 1 3.845-2.283 38 38 0 0 1 3.623-1.79l-1.067-3.034a38 38 0 0 0-3.622 1.79 85 85 0 0 0-3.845 2.283 99 99 0 0 0-3.865 2.589q-1.906 1.356-3.735 2.741-1.83 1.386-3.492 2.753a106 106 0 0 0-3.048 2.579z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint47_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M92.097 124.333q-.368-.66-1.066-1.127a6.1 6.1 0 0 0-1.48-.784 8.6 8.6 0 0 0-1.745-.49 20 20 0 0 0-1.804-.225l-1.066-3.034q.895.07 1.803.225a8.6 8.6 0 0 1 1.745.49 6.1 6.1 0 0 1 1.481.784q.697.468 1.065 1.127z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M71.357 132.807q.587-.854 1.411-1.958.864-1.117 1.802-2.31a188 188 0 0 1 3.908-4.662q.915-1.044 1.63-1.85.752-.818 1.18-1.234l-1.066-3.034q-.428.416-1.18 1.234-.715.806-1.63 1.85-.916 1.045-1.93 2.262a188 188 0 0 0-1.979 2.4q-.938 1.193-1.801 2.31-.825 1.104-1.411 1.958z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m81.288 120.792-.006-.017-1.066-3.034.006.018z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint48_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M81.286 120.778a1.86 1.86 0 0 0-.556-.791 5.7 5.7 0 0 0-.956-.668 7.5 7.5 0 0 0-1.132-.524 31 31 0 0 0-1.118-.441l-1.066-3.034q.54.2 1.118.441a7.5 7.5 0 0 1 1.132.524q.541.305.956.668.406.356.556.791z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint49_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M77.52 118.352q-.645.255-1.71.854-1.05.577-2.415 1.429-1.352.83-2.945 1.859l-3.26 2.134q-1.68 1.127-3.435 2.278a658 658 0 0 1-3.425 2.203l-1.066-3.033q1.68-1.075 3.424-2.204 1.756-1.151 3.436-2.278l3.26-2.134a148 148 0 0 1 2.945-1.859 52 52 0 0 1 2.415-1.429q1.064-.598 1.71-.854z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint50_linear_8257_3126)",
    fillRule: "evenodd",
    d: "M86.001 121.707a27.7 27.7 0 0 0-3.956 2.476 83 83 0 0 0-3.845 3.04 772 772 0 0 0-3.577 3.061 38 38 0 0 1-3.266 2.524l-1.066-3.034a38 38 0 0 0 3.266-2.523q1.737-1.497 3.576-3.062a84 84 0 0 1 3.846-3.04 27.7 27.7 0 0 1 3.956-2.476z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint51_linear_8257_3126)",
    fillRule: "evenodd",
    d: "m117 112.194 10.427 3.866c2.302.853 4.058 2.454 4.882 4.45s.648 4.224-.489 6.193l-19.747 34.202a9 9 0 0 1-2.306 2.601 10.8 10.8 0 0 1-3.281 1.711c-1.207.39-2.482.58-3.753.561a11 11 0 0 1-3.652-.676l-10.427-3.867c-1.69-.623-3.094-1.663-4.035-2.985l-3.174-4.479-4.922 1.071c-2.066.438-4.212.308-6.114-.373l-32.14-11.917a9.2 9.2 0 0 1-2.995-1.797 7.44 7.44 0 0 1-1.887-2.654 6.7 6.7 0 0 1-.49-3.106 7.3 7.3 0 0 1 .98-3.086l19.746-34.203c1.137-1.969 3.142-3.518 5.573-4.307s5.091-.752 7.393.101l32.192 11.937c1.884.714 3.4 1.943 4.312 3.494l2.193 3.71 6.262-.98c1.868-.281 3.765-.096 5.452.533m-26.244 22.295c.287.404.716.722 1.231.913.691.256 1.49.267 2.22.03s1.333-.702 1.674-1.293c.254-.441.35-.929.276-1.402a2.15 2.15 0 0 0-.696-1.255 2.9 2.9 0 0 0-1.433-.685 3.47 3.47 0 0 0-1.687.115 3.1 3.1 0 0 0-1.372.877c-.35.395-.557.863-.595 1.343-.038.481.095.953.382 1.357m-2.08 11.205c.498-.261.9-.635 1.155-1.076.341-.591.394-1.261.147-1.86s-.775-1.08-1.466-1.336a3.36 3.36 0 0 0-1.666-.162 3.34 3.34 0 0 0-1.537.645 2.55 2.55 0 0 0-.892 1.233c-.15.47-.13.959.054 1.406s.526.832.982 1.106a3.17 3.17 0 0 0 1.58.431 3.5 3.5 0 0 0 1.643-.387m8.13-21.684c.287.404.716.721 1.231.912.691.257 1.49.268 2.22.031s1.333-.702 1.674-1.294c.255-.441.351-.928.276-1.401a2.15 2.15 0 0 0-.696-1.255 2.9 2.9 0 0 0-1.432-.685 3.5 3.5 0 0 0-1.687.115 3.1 3.1 0 0 0-1.373.877c-.35.395-.557.862-.595 1.343s.095.953.382 1.357M71.08 113.716l-.376-.374a16.7 16.7 0 0 0-2.975-1.6 21.5 21.5 0 0 0-3.364-1.09 21.4 21.4 0 0 0-3.533-.579 18 18 0 0 0-3.397-.006q-1.618.157-3.015.632-1.384.452-2.355 1.268-.743.639-1.04 1.207-.297.57-.225 1.092a1.9 1.9 0 0 0 .463.981q.403.438 1.034.802.335.177.785.369l1.028.381q.724-1.037 1.515-1.814a5.9 5.9 0 0 1 1.921-1.221q1.117-.421 2.675-.418 1.57-.018 3.852.514a121 121 0 0 0-2.782 3.252 98 98 0 0 0-3.04 3.861 64 64 0 0 0-2.67 3.92q-1.18 1.938-1.718 3.463.24.663.708 1.098.492.444 1.11.777.606.355 1.3.613.707.288 1.415.629a151 151 0 0 1 5.575-4.201 149 149 0 0 0 5.94-4.509 54 54 0 0 0-1.693 2.611 61 61 0 0 0-1.266 2.299q-.581 1.116-1.162 2.285-.543 1.156-1.248 2.593-.384.771.06 1.301.455.561 1.292.95a11.3 11.3 0 0 0 1.837.707 47 47 0 0 1 1.694.524 104 104 0 0 1 3.048-2.578q1.663-1.368 3.492-2.754 1.83-1.385 3.735-2.741a99 99 0 0 1 3.865-2.589 84 84 0 0 1 3.845-2.282 38 38 0 0 1 3.623-1.791 3.3 3.3 0 0 0-1.066-1.126 6.1 6.1 0 0 0-1.48-.785 8.7 8.7 0 0 0-1.745-.49 20 20 0 0 0-1.804-.225 27.7 27.7 0 0 0-3.956 2.477 83 83 0 0 0-3.846 3.04 767 767 0 0 0-3.576 3.061 38 38 0 0 1-3.266 2.524q.586-.854 1.41-1.958.863-1.116 1.802-2.31a189 189 0 0 1 3.908-4.662q.916-1.044 1.63-1.85.753-.817 1.18-1.234a1.85 1.85 0 0 0-.562-.809 5.7 5.7 0 0 0-.956-.668 7.5 7.5 0 0 0-1.132-.524 31 31 0 0 0-1.118-.441q-.647.257-1.71.855-1.05.576-2.415 1.428-1.353.831-2.945 1.86l-3.26 2.134q-1.68 1.126-3.436 2.277a660 660 0 0 1-3.424 2.204l2.057-2.267q1.129-1.252 2.27-2.527 1.18-1.286 2.308-2.539a127 127 0 0 1 2.147-2.26 69 69 0 0 1 1.772-1.772q.792-.724 1.26-.995",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8257_3126",
    x1: 150.009,
    x2: 190.098,
    y1: 223.2,
    y2: 332.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8257_3126",
    x1: 100.695,
    x2: 108.272,
    y1: 348.38,
    y2: 375.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8257_3126",
    x1: 135.131,
    x2: 139.192,
    y1: 284.552,
    y2: 297.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8257_3126",
    x1: 141.297,
    x2: 145.371,
    y1: 307.954,
    y2: 320.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8257_3126",
    x1: 128.867,
    x2: 132.928,
    y1: 261.176,
    y2: 273.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8257_3126",
    x1: 60.803,
    x2: 68.325,
    y1: 297.603,
    y2: 322.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8257_3126",
    x1: 66.841,
    x2: 84.606,
    y1: 303.871,
    y2: 337.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8257_3126",
    x1: 89.931,
    x2: 102.456,
    y1: 307.604,
    y2: 331.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8257_3126",
    x1: 110.538,
    x2: 112.364,
    y1: 276.609,
    y2: 282.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8257_3126",
    x1: 92.306,
    x2: 93.73,
    y1: 286.244,
    y2: 291.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8257_3126",
    x1: 78.823,
    x2: 92.124,
    y1: 290.454,
    y2: 327.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8257_3126",
    x1: 97.915,
    x2: 111.09,
    y1: 282.576,
    y2: 317.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8257_3126",
    x1: 31.432,
    x2: 204.208,
    y1: 278.412,
    y2: 346.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#FFE79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#FFC559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B6103"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8257_3126",
    x1: 1438.42,
    x2: 1389.41,
    y1: 97.728,
    y2: 203.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8257_3126",
    x1: 1315.03,
    x2: 1301.41,
    y1: 151.373,
    y2: 175.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8257_3126",
    x1: 1384.51,
    x2: 1378.36,
    y1: 130.59,
    y2: 142.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8257_3126",
    x1: 1372.33,
    x2: 1366.18,
    y1: 151.499,
    y2: 163.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8257_3126",
    x1: 1396.61,
    x2: 1390.46,
    y1: 109.632,
    y2: 121.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8257_3126",
    x1: 1322.73,
    x2: 1310.48,
    y1: 87.261,
    y2: 110.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8257_3126",
    x1: 1322.56,
    x2: 1311.31,
    y1: 95.963,
    y2: 132.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8257_3126",
    x1: 1336.25,
    x2: 1327.92,
    y1: 114.93,
    y2: 140.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8257_3126",
    x1: 1372.74,
    x2: 1369.54,
    y1: 107.584,
    y2: 113.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8257_3126",
    x1: 1353.04,
    x2: 1350.55,
    y1: 101.506,
    y2: 106.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8257_3126",
    x1: 1340.52,
    x2: 1323.69,
    y1: 94.948,
    y2: 130.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8257_3126",
    x1: 1359.6,
    x2: 1344.13,
    y1: 102.878,
    y2: 136.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8257_3126",
    x1: 1315.53,
    x2: 1389.43,
    y1: 52.923,
    y2: 223.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#FFE79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#FFC559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B6103"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8257_3126",
    x1: 1364.92,
    x2: 1398.44,
    y1: 260.889,
    y2: 308.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8257_3126",
    x1: 1357.3,
    x2: 1364.44,
    y1: 327.728,
    y2: 339.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8257_3126",
    x1: 1365.68,
    x2: 1369.29,
    y1: 292.445,
    y2: 298.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8257_3126",
    x1: 1371.68,
    x2: 1375.3,
    y1: 302.949,
    y2: 308.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8257_3126",
    x1: 1359.63,
    x2: 1363.24,
    y1: 281.965,
    y2: 287.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_8257_3126",
    x1: 1331.47,
    x2: 1338.31,
    y1: 308.367,
    y2: 319.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8257_3126",
    x1: 1335.2,
    x2: 1348.13,
    y1: 310.612,
    y2: 324.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_8257_3126",
    x1: 1346.83,
    x2: 1356.02,
    y1: 309.427,
    y2: 319.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_8257_3126",
    x1: 1352.77,
    x2: 1354.47,
    y1: 291.791,
    y2: 294.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_8257_3126",
    x1: 1345.21,
    x2: 1346.54,
    y1: 298.804,
    y2: 301.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_8257_3126",
    x1: 1339.24,
    x2: 1350.47,
    y1: 302.582,
    y2: 318.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_8257_3126",
    x1: 1347.45,
    x2: 1358.34,
    y1: 296.306,
    y2: 311.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_8257_3126",
    x1: 1314.8,
    x2: 1407.08,
    y1: 302.899,
    y2: 313.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#FFE79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#FFC559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B6103"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_8257_3126",
    x1: 122.207,
    x2: 97.705,
    y1: 114.865,
    y2: 167.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_8257_3126",
    x1: 60.515,
    x2: 53.706,
    y1: 141.687,
    y2: 153.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_8257_3126",
    x1: 95.257,
    x2: 92.181,
    y1: 131.295,
    y2: 137.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_8257_3126",
    x1: 89.164,
    x2: 86.089,
    y1: 141.749,
    y2: 147.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_8257_3126",
    x1: 101.307,
    x2: 98.231,
    y1: 120.816,
    y2: 126.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_8257_3126",
    x1: 64.364,
    x2: 58.242,
    y1: 109.631,
    y2: 121.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_8257_3126",
    x1: 64.283,
    x2: 58.655,
    y1: 113.982,
    y2: 132.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_8257_3126",
    x1: 71.127,
    x2: 66.961,
    y1: 123.465,
    y2: 136.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_8257_3126",
    x1: 89.37,
    x2: 87.771,
    y1: 119.792,
    y2: 122.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_8257_3126",
    x1: 79.518,
    x2: 78.274,
    y1: 116.753,
    y2: 119.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_8257_3126",
    x1: 73.261,
    x2: 64.845,
    y1: 113.474,
    y2: 131.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_8257_3126",
    x1: 82.798,
    x2: 75.064,
    y1: 117.439,
    y2: 134.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_8257_3126",
    x1: 60.764,
    x2: 97.713,
    y1: 92.462,
    y2: 177.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#FFE79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#FFC559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B6103"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8257_3126"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m0 235 185.458-49.693 49.693 185.458-185.458 49.693z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8257_3126"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1324 0 166.277 96-96 166.277-166.277-96z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8257_3126"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1294 286 83.138-48 48 83.138-83.138 48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_8257_3126"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m65 66 83.138 48-48 83.138-83.138-48z"
  })))));
};
export default SvgBgRaffleTickets;